import styled from "styled-components";
import { Div } from "../../../common/ui/widgets";


export const NotificationTileWrapper = styled(Div)`
  font-family: "Helvetica Neue";
  .channel-type{
    margin-left: ${(props) => props.theme.margin100};
    padding: ${(props) => props.theme.padding2} ${(props) => props.theme.padding6};
    background-color: #E25153;
    color: #FFFFFF;
    font-size: ${(props) => props.theme.font14};
    font-weight: ${(props) => props.theme.fontWeight500};
  }
  `